module.exports = __webpack_public_path__ + "img/regional_negativ.a4a75291.png";